import { HttpClient } from '@adapters/HttpClient';
import type { Option, Country } from './types';
import globalCache from '@shared/lib/GlobalCache';

export class CountriesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    return globalCache.getOrSet('countries', async () => {
      const raw = await this.httpClient.get<any>('/countries');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((c: any) => ({
        id: String(c.id),
        name: c.name,
      }));
    });
  }

  async getCountries(): Promise<Country[]> {
    return globalCache.getOrSet('countries-full', async () => {
      const raw = await this.httpClient.get<any>('/countries');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((c: any) => ({
        id: c.id,
        name: c.name,
        iso2: c.iso2,
        iso3: c.iso3,
        phoneCode: c.phoneCode || c.phone_code || c.dial_code || '',
      }));
    });
  }
}
